import { createPortal } from "react-dom";
import { LogIn, UserPlus, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface AuthRequiredModalProps {
  open: boolean;
  onClose: () => void;
}

const AuthRequiredModal = ({ open, onClose }: AuthRequiredModalProps) => {
  const navigate = useNavigate();

  if (!open) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      <div
        className="relative w-full max-w-sm rounded-3xl p-8 text-center"
        style={{
          background: "linear-gradient(135deg, rgba(40,30,20,0.85) 0%, rgba(30,20,15,0.92) 100%)",
          backdropFilter: "blur(24px)",
          WebkitBackdropFilter: "blur(24px)",
          border: "1px solid rgba(255,255,255,0.25)",
          boxShadow: "0 12px 48px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.25)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-16 h-16 rounded-full mx-auto mb-5 flex items-center justify-center bg-primary/20">
          <Lock className="w-7 h-7 text-primary" />
        </div>
        <h3 className="font-marquee text-xl font-bold text-foreground mb-2">Prisijungimas būtinas norint ĮSIGYTI PAMOKAS</h3>
        <p className="text-sm text-foreground/60 mb-8 leading-relaxed">
          Norint įsigyti PAMOKAS, prašome prisijungti arba sukurti paskyrą.
        </p>
        <div className="flex flex-col gap-3">
          <Button onClick={() => { onClose(); navigate("/auth?mode=login"); }} className="w-full py-5 rounded-xl">
            <LogIn className="mr-2 h-4 w-4" /> Prisijungti
          </Button>
          <Button onClick={() => { onClose(); navigate("/auth?mode=signup"); }} variant="outline" className="w-full py-5 rounded-xl border-foreground/20 text-foreground hover:bg-foreground/10">
            <UserPlus className="mr-2 h-4 w-4" /> Registruotis
          </Button>
        </div>
        <button onClick={onClose} className="mt-4 text-xs text-foreground/40 hover:text-foreground/60 transition-colors">
          Uždaryti
        </button>
      </div>
    </div>,
    document.body
  );
};

export default AuthRequiredModal;
